import { Temporal } from 'temporal-polyfill';
import { OrgFeedbackType } from './data/org-shared.js';
import type { SchoolReport } from './data/school-report.js';
import { FrequentTimeZones } from './temporal-utils/index.js';

/** Family-program orgs (`parentFeedback`) are excluded from weekly school reports. */
export function isFamilyOrgExcludedFromSchoolReports(feedbackType: string | null | undefined): boolean {
  return feedbackType === OrgFeedbackType.parentFeedback;
}

export function countSessionsAttendedForSchoolReport(row: Pick<SchoolReport, 'sessions' | 'studentId'>): number {
  return row.sessions.filter((session) => {
    const feedback = session.sessionFeedbacks?.find((f) => f.studentId === row.studentId);
    return feedback?.studentAttended === true;
  }).length;
}

/**
 * Returns the Mon 00:00:00 → Fri 23:59:59 window for the school week that
 * contains (or most recently preceded) the given instant, in US Central time.
 *
 * Using fixed calendar boundaries instead of a rolling lookback means the
 * window is identical regardless of when exactly the cron fires on Saturday.
 */
export function currentSchoolWeekRange(now: Temporal.Instant): {
  startInstant: Temporal.Instant;
  endInstant: Temporal.Instant;
} {
  const nowInCentral = now.toZonedDateTimeISO(FrequentTimeZones.UsCentral);
  // Temporal dayOfWeek: 1 = Monday … 7 = Sunday
  const mondayStart = nowInCentral
    .subtract({ days: nowInCentral.dayOfWeek - 1 })
    .with({ hour: 0, minute: 0, second: 0, millisecond: 0, microsecond: 0, nanosecond: 0 });
  const fridayEnd = mondayStart
    .add({ days: 4 })
    .with({ hour: 23, minute: 59, second: 59, millisecond: 999, microsecond: 999, nanosecond: 999 });
  return { startInstant: mondayStart.toInstant(), endInstant: fridayEnd.toInstant() };
}
